import { NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventType } from '@azure/msal-browser';
import { LanguageEditorComponent } from 'components/core/language-editor/language-editor.component';
import { LeftPanelComponent } from 'components/core/left-panel/left-panel.component';
import { NavMenuComponent } from 'components/core/navmenu/navmenu.component';
import { StatusMessagesComponent } from 'components/core/notifications/status-messages.component';
import { DropdownListComponent } from 'components/input/custom-select/dropdown-list';
import { IconComponent } from 'components/layout/icon/icon.component';
import { CoderDebugComponent } from 'components/test/coder-debug/coder-debug.component';
import { environment } from 'environments/environment';
import { LanguageService } from 'services/language.service';
import { LoggingService } from 'services/logging.service';
import { NavigationService } from 'services/navigation.service';
import { PushService } from 'services/push.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'app',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [NavMenuComponent, IconComponent, NgClass, LeftPanelComponent, RouterOutlet, LanguageEditorComponent, CoderDebugComponent, DropdownListComponent, StatusMessagesComponent]
})
export class AppComponent {

	public get ready() { return this.languageService.ready && this.userService.ready; }
	public errors: Error[] = [];

	constructor(
		private readonly languageService: LanguageService,
		private readonly userService: UserService,
		private readonly pushService: PushService,
		readonly navigationService: NavigationService,
		loggingService: LoggingService,
		msalBroadcastService: MsalBroadcastService,
		msalService: MsalService
		)
	{
		languageService.onError.subscribe(error => { this.errors.push(error); console.error(error); });
		userService.onError.subscribe(error => { this.errors.push(error); console.error(error); });
		loggingService.onError.subscribe(error => { this.errors.push(error); console.error(error); });
		msalBroadcastService.msalSubject$.subscribe((result) => {
			if (result.error) {
				if (localStorage.getItem('localStorageManualCleared') != 'true') {
					for (const key in localStorage) {
						if (key.startsWith('msal.')) localStorage.removeItem(key);
					}
					localStorage.setItem('localStorageManualCleared', 'true');
					msalService.acquireTokenRedirect({ scopes: [environment.scope] });
				}
				this.errors.push(result.error);
				console.error(result.error);
			}
			if (result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)
				localStorage.removeItem('localStorageManualCleared');
			
		});
	}

	openCurrentUrl() {
		window.open(window.location.href);
	}

	getDetailsString(error: Error): string | undefined { return error instanceof HttpErrorResponse && typeof error.error === 'string' ? error.error : undefined; }

	@HostListener('window:beforeunload', [ '$event' ])
	@HostListener('window:unload', [ '$event' ])
	unloadHandler(event: any) {
		this.pushService.stopConnection();
	}	
}
